// extracted by mini-css-extract-plugin
export default {"textButton":"ImportOIDC_textButton__+v8xV","error":"ImportOIDC_error__em+-A"};